module.exports = __webpack_public_path__ + "fonts/Kinetika-BlackItalic.7c92da8a.eot";